import { defineMessages } from "@formatjs/intl";

export default defineMessages({
  Title: {
    id: "AutoDebit.Title",
    defaultMessage: "預金口座振替・自動払込登録",
    description: "title of AutoDebit page",
  },
  Description: {
    id: "AutoDebit.Description",
    defaultMessage:
      "以下の順序に従い、預金口座振替・自動払込情報をご登録ください。",
    description: "Description of AutoDebit page",
  },
  "Note.Title": {
    id: "AutoDebit.Note.Title",
    defaultMessage: "Note",
    description: "title of note",
  },
  Note: {
    id: "AutoDebit.Note",
    defaultMessage: `The rest of the process will be in <strong>Japanese only.</strong>
      <br></br> For further instructions, please read the guide below.`,
    description: "Description of AutoDebit page",
  },
  NoteLink: {
    id: "AutoDebit.NoteLink",
    defaultMessage: `Guide for Registration`,
    description: "Description of AutoDebit page",
  },
  Step1: {
    id: "AutoDebit.Step1",
    defaultMessage: "ログイン",
    description: "description of Step1",
  },
  Step2: {
    id: "AutoDebit.Step2",
    defaultMessage: "金融機関の登録※",
    description: "description of Step2",
  },
  Step3: {
    id: "AutoDebit.Step3",
    defaultMessage: "銀行口座情報の登録※",
    description: "description of Step3",
  },
  Step4: {
    id: "AutoDebit.Step4",
    defaultMessage: "完了",
    description: "description of Step4",
  },
  StepTip: {
    id: "AutoDebit.StepTip",
    defaultMessage:
      "※ビレッジハウスの提携会社、お客様のご利用の金融機関での登録になります。",
    description: "tip of flow",
  },
  FormTip: {
    id: "AutoDebit.FormTip",
    defaultMessage: `ビレッジハウスからお送りしている情報をご入力ください。<br></br>
    「申込番号」が8桁の場合、最初のゼロを除いた数字をご入力ください。`,
    description: "tip of form",
  },
  "ApplicationNumber.Title": {
    id: "AutoDebit.ApplicationNumber.Title",
    defaultMessage: `申込番号
    <span>半角数字</span>
    `,
    description: "title of ApplicationNumber",
  },
  "ApplicationNumber.Placeholder": {
    id: "AutoDebit.ApplicationNumber.Placeholder",
    defaultMessage: `記入例: 1234567`,
    description: "Placeholder of ApplicationNumber",
  },
  "ApplicationNumber.Error.Required": {
    id: "AutoDebit.ApplicationNumber.Error.Required",
    defaultMessage: "申込番号をご入力ください",
    description: "Required error message of ApplicationNumber",
  },
  "ApplicationNumber.Error.Other": {
    id: "AutoDebit.ApplicationNumber.Error.Other",
    defaultMessage: "7桁の半角数字をご入力ください",
    description: "Other error message of ApplicationNumber",
  },
  "Telephone.Title": {
    id: "AutoDebit.Telephone.Title",
    defaultMessage: `電話番号<span>半角数字ハイフンなし</span>
    `,
    description: "title of Telephone",
  },
  "Telephone.Placeholder": {
    id: "AutoDebit.Telephone.Placeholder",
    defaultMessage: `記入例: 0300000000`,
    description: "Placeholder of Telephone",
  },
  "Telephone.Error.Required": {
    id: "AutoDebit.Telephone.Error.Required",
    defaultMessage: "電話番号をご入力ください",
    description: "Required error message of Telephone",
  },
  "Telephone.Error.Other": {
    id: "AutoDebit.Telephone.Error.Other",
    defaultMessage: "10桁、または11桁の半角数字をご入力ください",
    description: "Other error message of Telephone",
  },
  "FullName.Title": {
    id: "AutoDebit.FullName.Title",
    defaultMessage: `氏 名<span>全角カタカナ</span>
    `,
    description: "title of FullName",
  },
  "FullName.Placeholder": {
    id: "AutoDebit.FullName.Placeholder",
    defaultMessage: "記入例: ヤマダ　タロウ",
    description: "Placeholder of FullName",
  },
  "FullName.Error.Required": {
    id: "AutoDebit.FullName.Error.Required",
    defaultMessage: "氏名をご入力ください",
    description: "Required error message of FullName",
  },
  "FullName.Error.Other": {
    id: "AutoDebit.FullName.Error.Other",
    defaultMessage:
      "金融機関への登録通りにご入力ください。 姓と名の間にスペースがある場合は、全角スペースでご入力ください（半角不可）。長さは30文字を超えることはできません。",
    description: "Other error message of FullName",
  },
  ContractClassification: {
    id: "AutoDebit.ContractClassification.Title",
    defaultMessage: "契約区分",
    description: "title of FullName",
  },
  "ContractClassification.Option1": {
    id: "AutoDebit.ContractClassification.Option1",
    defaultMessage: "個人",
    description: "Option1 of ContractClassification",
  },
  "ContractClassification.Option2": {
    id: "AutoDebit.ContractClassification.Option2",
    defaultMessage: "法人 <span>（生年月日不要）</span>",
    description: "Option2 of ContractClassification",
  },
  Birth: {
    id: "AutoDebit.Birth.Title",
    defaultMessage: "生年月日",
    description: "title of birth",
  },
  "Birth.Error.Required": {
    id: "AutoDebit.Birth.Error.Required",
    defaultMessage: "誕生日をご指定ください",
    description: "title of birth",
  },
  Privacy: {
    id: "AutoDebit.Privacy",
    defaultMessage: "プライバシーポリシー",
    description: "name of privacy link ",
  },
  Submit: {
    id: "AutoDebit.Submit",
    defaultMessage: `プライバシーポリシーに同意し、<br></br>”銀行口座情報の登録”へ進む`,
    description: "name of privacy link ",
  },
  FinalExplanation: {
    id: "AutoDebit.FinalExplanation",
    defaultMessage: `金融機関によっては本人確認のために記帳済の通帳をお手元にご用意いただく場合がございます。`,
    description: "final explanation of the page",
  },
  Failed: {
    id: "AutoDebit.Failed",
    defaultMessage:
      "サービスが一時的にご利用いただけません。後ほどお試しください。",
    description: "failed to submit the form",
  },
  NotificationTitle: {
    id: "AutoDebit.NotificationTitle",
    defaultMessage: `サービス停止のお知らせ`,
    description: "title of notification",
  },
  Notification: {
    id: "AutoDebit.Notification",
    defaultMessage: `預金口座振替・自動払込登録は現在、サービスを停止しております。<br></br>
    サービス停止日時を確認し、再度お越しください。<br></br>
    <br></br>
    サービス停止日時<br></br>
    2024年12月28日～2025年1月5日`,
    description: "notification message",
  },
});
